import React, { useRef, useState } from "react";
import styles from "./UserFormDetail.module.css";

import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { countriesArray } from "../../components/List";
import { InputMask } from "primereact/inputmask";
import { Dialog } from "primereact/dialog";

import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { GetCompanies } from "../../store/company-store/company-actions";
import { Checkbox } from "primereact/checkbox";
import { userActions } from "../../store/auth-store/auth-slice";
import { getTokenInfo } from "../../utils/Guard";
import { GetUserById } from "../../store/auth-store/auth-actions";
import {
  AddUser,
  CreateOrder,
  CreateQuote,
  RemoveUser,
  SendQuote,
} from "../../store/orden-store/orden-actions";

import { GetCourse } from "../../store/course-store/course-actions";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import { ordenActions } from "../../store/orden-store/orden-slice";
import Quote from "../../Templates/Quote";
import { SelectButton } from "primereact/selectbutton";
import ApprovedQuote from "../../components/approvedQuote/ApprovedQuote";
import Loading from "../../components/loading/Loading";
import { Card } from "primereact/card";
import { GetDiscountAvailable } from "../../store/discount-store/discount-actions";
import { uiActions } from "../../store/ui-slice";
let getDiscount = true;

const UserFormDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const [count, setCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [subTotal, setsubTotal] = useState(0);
  const [discountVal, setDiscount] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [totalPay, setTotalPay] = useState(0);
  const [visibleUser, setVisibleUser] = useState(false);
  const [userEmail, setUserEmail] = useState("");

  const param = useParams();
  const userInfo = getTokenInfo();
  const stepperRef = useRef(null);

  const [value, setValue] = useState(null);
  const [pdf, setPdf] = useState(null);
  const options = ["Si", "No"];

  const quote = useSelector((state) => state.orden.quote);

  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedCharge, setSelectedCharge] = useState({ code: 0, name: "" });
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [countries, setCountries] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [users, setUsers] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [showDiscount, setShowDiscount] = useState(false);
  const [visible, setVisible] = useState(false);

  const company = useSelector((state) => state.company);
  const discount = useSelector((state) => state.discount.discount);
  const course = useSelector((state) => state.course.course);
  const notification = useSelector((state) => state.ui.notification);
  const country = countriesArray;
  const user = useSelector((state) => state.auth.auth);

  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const [selectedPaymentMethod, setPaymentMethod] = useState({
    code: 0,
    name: "",
  });
  const [selectedStatusMethod, setSelectedStatus] = useState({
    code: 0,
    name: "",
    color: "",
  });
  const [selectedTipo, setSelecedtipo] = useState({ code: "", name: "" });
  const [discountCode, setDiscountCode] = useState("");

  const [orden, setOrden] = useState({
    course: { id: parseInt(param.courseid) },
    ordenType: { id: 2 },
    paymentMethod: { id: 1 },
    status: { id: 1 },
    amount: 0,
    discountCode: "",
    Category: "",
    taxBill: false,
    RNC: "",
    users: [],
  });

  const [newQuote, setNewQuote] = useState({
    course: { id: parseInt(param.courseid) },
    ordenType: { id: 2 },
    paymentMethod: {
      id: 1,
    },
    status: {
      id: 9,
    },
    amount: course.price,
    discountCode: "",
    category: "",
    quantity: 1,
  });


  useEffect(() => {
    if (course && course.id === 0) {
      dispatch(GetCourse(param.courseId));
    }
  }, [course, dispatch, param.courseId]);

  useEffect(() => {
    if (course && course.id > 0) {
      setsubTotal(count * course.price);
      setTotal(subTotal - discountVal);
    }
  }, [course, count, discountVal, subTotal]);

  useEffect(() => {
    if (getDiscount === true) {
      getDiscount = false;
      dispatch(
        GetDiscountAvailable("capacitaciones@aba.org.do", count, param.courseId)
      );
    }
  }, [count, discount, dispatch, param.courseId]);

  useEffect(() => {
    if (discount && discount.id > 0 && discount.grupal === true && count >= 3) {
      if (discount.percentage === true) {
        setDiscount(count * course.price * (discount.discountPercentage / 100));
      }
      if (discount.nominal === true) {
        setDiscount(count * discount.discountNominal);
      }
    }
    if (discount && discount.id > 0 && discount.grupal === true && count < 3) {
      setDiscount(0);
    }
    if (discount && discount.id > 0 && discount.grupal === false) {
      if (discount.percentage === true) {
        setDiscount(count * course.price * (discount.discountPercentage / 100));
      }
      if (discount.nominal === true) {
        setDiscount(count * discount.discountNominal);
      }
    }
  }, [course.price, count, discount, total]);

  const [visibleQuote, setVisibleQuote] = useState(false);

  const reportTemplateRef = useRef(null);

  useEffect(() => {
    if (
      quote !== undefined &&
      quote.orderNumber !== undefined &&
      quote.orderNumber > 0 &&
      pdf === null
      // && visibleQuote === true
    ) {
      handleGeneratePdf();
    }
    if (
      pdf !== null &&
      quote !== undefined &&
      quote.orderNumber !== undefined &&
      quote.orderNumber > 0
    ) {
      dispatch(SendQuote(quote, pdf.output("blob"), "aulaaba.aba.org.do"));
      dispatch(ordenActions.setQuote({}));
    }
  }, [
    dispatch,
    param.courseId,
    pdf,
    quote,
    // visibleQuote,
  ]);

  useEffect(() => {
    if (course.id === null || course.id === undefined || course.id === 0) {
      if (
        userInfo !== undefined &&
        userInfo !== null &&
        param.courseid !== undefined &&
        userInfo.email !== undefined &&
        userInfo.email !== null
      ) {
        dispatch(GetCourse(param.courseid, userInfo.email));
      } else if (param.courseid !== undefined) {
        dispatch(GetCourse(param.courseid, 0, "aulaaba.aba.org.do"));
      }
    }
  }, [course, param.courseid, dispatch]);

  useEffect(() => {
    if (company.companies === undefined || company.companies.length === 0) {
      dispatch(GetCompanies("capacitaciones@aba.org.do"));
    }
  }, [company.companies, dispatch]);

  useEffect(() => {
    if (country !== undefined && country.length > 0) {
      var id = 0;
      const listCountries = country.map((country) => {
        id++;
        return {
          code: country.name,
          name: country.name,
          flag: country.abreviatura,
        };
      });
      setCountries(listCountries);
    }
  }, [country]);

  const onChangeOrdenHandler = (id, value) => {
    let newOrden = { ...orden };
    if (id === "paymentMethod") {
      newOrden.paymentMethod.id = value.code;
      setPaymentMethod(value);
    }
    if (id === "status") {
      newOrden.status.id = value.code;
      setSelectedStatus(value);
    }
    if (id === "type") {
      newOrden.Category = value.code;
      setSelecedtipo(value);
    }
    if (id === "discountCode") {
      newOrden.discountCode = value;
      setDiscountCode(value);
    }
    if (id === "users") {
      newOrden.users.push(value);
    }
    if (id === "taxBill") {
      newOrden.taxBill = value;
    }
    if (id === "rnc") {
      newOrden.RNC = value;
    }
    newOrden.amount = course.price;
    newOrden.course = course;
    setOrden(newOrden);
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (count === 0) {
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Debe agregar al menos un participante",
        })
      );
    } else {
      const orden = {
        userName: userInfo.Email,
        conferecenCodeName: params.courseId,
        discountCode: discount.discountCode,
        amount: subTotal,
        quantityOfUsers: count,
      };
      dispatch(CreateOrder(userInfo.Email, orden));
      setTimeout(function () {
        window.location.href = "/orden/" + params.courseId;
      }, 1500);
    }
  };

  const onChangeQuoteHandler = (id, value) => {
    let quote = { ...newQuote };
    quote.paymentMethod.id = 1;
    quote.status.id = 9;
    quote.amount = course.price;

    if (id === "discountCode") {
      quote.discountCode = value;
    }
    if (id === "quantity") {
      quote.quantity = value;
      if (value === 1) {
        quote.category = "individual";
      } else if (value > 1) {
        quote.category = "grupal";
      }
    }

    setNewQuote(quote);
  };

  const handleGeneratePdf = async () => {
    const options = {
      method: "open",
      resolution: Resolution.LOW,
      page: {
        margin: Margin.SMALL,
        format: "a4",
      },
      canvas: {
        mimeType: "image/png",
        qualityRatio: 1,
      },
      overrides: {
        pdf: {
          compress: true,
        },
        canvas: {
          useCORS: true,
        },
      },
    };
    const quotePdf = await generatePDF(reportTemplateRef, options);

    setPdf(quotePdf);
    stepperRef.current.nextCallback();
  };

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <img
            alt={option.name}
            src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
            style={{ width: "18px" }}
          />
          <div style={{ marginLeft: "5%" }}>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const onCreateQuoteHandler = () => {
    dispatch(
      ordenActions.setOrden({
        orden: {},
      })
    );
    var compa = {};
    if (
      selectedCompany !== null &&
      selectedCompany !== undefined &&
      selectedCompany.code !== undefined
    ) {
      compa = { ...selectedCompany };
    } else {
      compa = {
        code: 0,
        name: selectedCompany,
      };
    }

    const q = {
      user: {
        Id: user.id,
        Name: user.name,
        LastName: user.lastName,
        Email: user.email,
        Identification: user.identification,
        CellPhone: user.cellPhone,
        Country: selectedCountry.name,
        company: compa,
      },
      course: course,
      quantity: newQuote.quantity,
      discountCode: orden.discountCode,
      rnc: orden.RNC,
      orderNumber: 0,
    };

    dispatch(CreateQuote(q, user.email));

    // setRefresh(true);
  };

  const onChangeCountriesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCountry({
      code: value.code,
      name: value.name,
      flag: value.flag,
    });
  };

  const onChangeCompaniesHandler = (id, value) => {
    dispatch(
      userActions.modifyPropertyValue({
        id,
        value: {
          id: 0,
          name: value,
        },
      })
    );
    setSelectedCompany(value);


  };

  useEffect(() => {
    if (company.companies !== undefined && company.companies.length > 0) {
      const listCompanies = company.companies.map((company) => {
        return {
          code: company.id,
          name: company.name,
          rnc: company.rnc,
        };
      });

      setCompanies(listCompanies);
    }
  }, [company.companies]);

  const countryOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center" style={{ width: "100px" }}>
        <img
          alt={option.name}
          src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
          style={{ width: "18px" }}
        />
        <div style={{ marginLeft: "5%" }}>{option.name}</div>
      </div>
    );
  };


  const onChangeHandler = (id, value) => {
    if (id !== "charge" && id !== "department") {
      dispatch(userActions.modifyPropertyValue({ id, value }));
      if (value !== "") {
        dispatch(userActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(userActions.setFieldValid({ id, value: false }));
      }
    } else {
      dispatch(userActions.modifyPropertyValue({ id, value: { id: value } }));
    }
  };

  return (
    <>
      {countries.length <= 0 && companies.length <= 0 && (
        <>
          <Loading />
        </>
      )}
      {countries.length > 0 && companies.length > 0 && (
        <>
          <div className={styles.contribution}>
            {/* <h1 className={styles.formTitle}>Participante</h1> */}
            <div className={styles.facturationForm}>
              {/* <form className={styles.forms}> */}
              <div className={styles.forms}>
                <div className={styles.column}>
                  <label htmlFor="nombre">Nombre</label>
                  <InputText
                    value={user.name}
                    onChange={(e) => onChangeHandler("name", e.target.value)}
                    type="text"
                    id="name"
                  />
                </div>
                <div className={styles.column}>
                  <label htmlFor="apellido">Apellido</label>
                  <InputText
                    value={user.lastName}
                    onChange={(e) =>
                      onChangeHandler("lastName", e.target.value)
                    }
                    type="text"
                    id="lastName"
                  />
                </div>
                <div className={styles.column}>
                  <label htmlFor="correo">Correo</label>
                  <InputText
                    value={user.email}
                    onChange={(e) => onChangeHandler("email", e.target.value)}
                    type="text"
                    id="email"
                  />
                </div>
                {/* <div className={styles.column}>
                      <label htmlFor="telefono">Cédula</label>
                      <InputMask
                        id="identification"
                        value={user.identification}
                        onChange={(e) =>
                          onChangeHandler("identification", e.target.value)
                        }
                        mask="999-9999999-9"
                        placeholder="999-9999999-9"
                      />
                    </div> */}
                <div className={styles.column}>
                  <label htmlFor="telefono">Teléfono</label>
                  <InputMask
                    id="cellPhone"
                    value={user.cellPhone}
                    onChange={(e) => onChangeHandler("cellPhone", e.target.value)}
                    mask="+1999-999-9999"
                    placeholder="+1999-999-9999"
                  />
                </div>
                <div className={styles.column}>
                  <label htmlFor="pais">País</label>
                  <Dropdown
                    value={selectedCountry}
                    onChange={(e) => {
                      onChangeCountriesHandler("country", e.value);
                    }}
                    options={countries}
                    optionLabel="name"
                    placeholder="Seleccionar pais"
                    valueTemplate={selectedCountryTemplate}
                    filter
                    itemTemplate={countryOptionTemplate}
                    className={styles.profileDropdown}
                  />
                </div>

              </div>
              {/* </form> */}
            </div>
          </div>

          <div ref={reportTemplateRef}>
            <Quote quote={quote} />
          </div>
        </>
      )}
    </>
  );
};

export default UserFormDetail;
